import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserRound, House, QrCode, LogOut, Sun, Moon, Menu } from 'lucide-react';
import TempStorage from '../components/Storage.js';
import Loader from './Loader.js';
import { useDarkMode } from '../components/DarkModeContext.js';

export let infoUtente = [];
let isLoading = false;

const HamburgerMenu = ({ isVisible, setIsVisible }) => {
    const navigate = useNavigate();
    const { darkMode, toggleDarkMode } = useDarkMode();

    const handleLogout = () => {
        document.cookie.split(";").forEach(cookie => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
        });
        navigate('/');
    };

    document.addEventListener("click", function (event) {
        const menu = document.getElementById("menu");
        const hamburger = document.getElementById("hamburger");

        // Check if the click is outside the hamburger button and the menu button
        if (!hamburger.contains(event.target) && !menu.contains(event.target)) {
            setIsVisible(false);
        }
    });

    if (!isVisible) return null;

    return (
        <div id="hamburger" className="absolute bottom-20 right-0 mt-2 w-40 bg-white dark:bg-gray-800 rounded-md border-2 border-black dark:border-white shadow-lg mr-2">
            <ul className="text-black dark:text-white m-2">
                <button
                    className="flex items-center justify-between w-full px-8 py-4 hover:bg-gray-100 dark:hover:bg-gray-700"
                    onClick={() => navigate('/dashUtente/profilo')}
                >
                    <UserRound size={20} className="text-blue-500" /> Profilo
                </button>
                <button
                    className="flex items-center justify-between w-full px-8 py-4 hover:bg-gray-100 dark:hover:bg-gray-700"
                    onClick={handleLogout}
                >
                    <LogOut size={20} className="text-red-500" /> Logout
                </button>
            </ul>
            <div className="border-t border-gray-200 dark:border-gray-700 text-black dark:text-white m-2">
                <button
                    className="flex items-center justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 hover:rounded-md"
                    onClick={() => toggleDarkMode(true, infoUtente['ID'])}
                >
                    {darkMode ? (
                        <>
                            <Sun size={20} className="text-yellow-500" /> Modalità Chiara
                        </>
                    ) : (
                        <>
                            <Moon size={20} className="text-blue-900" /> Modalità Scura
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export const loadFooter = async () => {
    const idUser = TempStorage.exists('tokenUser') ? TempStorage.get('tokenUser') : document.cookie.indexOf('tokenUser') !== -1 ? document.cookie.split('tokenUser=')[1].split(";")[0] : null;
    try {
        isLoading = true;
        const response = await fetch('/getUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ IDUser: idUser }),
        });

        const data = await response.json();

        if (response.status === 500) {
            alert(data.error);
            console.log(data.error);
        }
        else {
            isLoading = false;
            infoUtente = data[0];
        }

    } catch (error) {
        alert("Errore nell'operazione");
        console.log(error);
    }
};

const FooterUtente = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    }

    return (
        <footer className="fixed bottom-0 left-0 w-full bg-white dark:bg-gray-800 text-black dark:text-white flex justify-between items-center px-4 py-4 border-t-2 border-black dark:border-white">
            {isLoading && <Loader />}
            <div className="relative justify-self-end">
                <button
                    onClick={() => navigate('/dashUtente')}
                    className="flex justify-center items-center text-yellow-500 mx-10"
                >
                    <House size={40} />
                </button>
            </div>
            <div className="relative">
                <button
                    onClick={() => {
                        if (window.location.pathname !== '/dashUtente/scan') {
                            navigate('/dashUtente/scan');
                        }
                        else {
                            window.location.reload();
                        }
                    }}
                    className="absolute -top-14 left-1/2 transform -translate-x-1/2 flex justify-center items-center p-4 bg-white dark:bg-gray-800 text-blue-500 border-2 border-black dark:border-white rounded-full shadow-lg"
                >
                    <QrCode size={60} />
                </button>
            </div>

            <button
                id="menu"
                className="flex justify-center items-center text-green-500 mx-10"
                onClick={toggleMenu}
            >
                <Menu size={40} />
            </button>
            <HamburgerMenu
                isVisible={menuOpen}
                setIsVisible={setMenuOpen}
            />
        </footer>
    );
};

export default FooterUtente;
